<div class="container">
    <div class="row">
        <div class="col-sm-12">
            <h1 class="main-heading">{{ 'rpe.vista-integrante.title' | translate }}</h1>
        </div>
    </div>
    <br>
    <div class="row">
        <rpe-entity-integrante-form-container>
        </rpe-entity-integrante-form-container>
    </div>
</div>